import React, {useState} from 'react';
import {connect} from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';
import iconBack from './images/icon-back.svg';
import cellcomEnergyLogo from './images/cellcomEnergyLogo.svg';
import icon100Hand from './images/icon-100-hand.svg';

const SalesHeader = (props) => {
  const [showLobbyPopup, setShowLobbyPopup] = useState(false);
  const [headerPopupAppearancesCount, setHeaderPopupAppearancesCount] = useState(0);

  const goToLobby = () => {
    window.location.href = Config.staticWebSiteUrl;
  };

  const isShowPopup = () => {
    if (headerPopupAppearancesCount > 2) {
      goToLobby();
    } else {
      setShowLobbyPopup(true);
      setHeaderPopupAppearancesCount(headerPopupAppearancesCount + 1);
    }
  };


  return (
    <div className='cellcom-sale-energy-header'>
      <div className='back-wrapper' >
        <button className='back' style={{backgroundImage:iconBack.bg()}} onClick={() => window.history.back()} />
      </div>
      <div className='logo-wrapper'>
        <button className='cellcom-energy-logo'  onClick={() => isShowPopup()}  style={{backgroundImage:cellcomEnergyLogo.bg()}}/>
      </div>

      <PopUp className='cellcom-sale-lobby-popup' showPopUp={showLobbyPopup} onClose={() => setShowLobbyPopup(false)}>
        <div className='popup_content'>
          <div className='icon-leave' style={{backgroundImage:icon100Hand.bg()}}></div>
          <div className='main-title-popup'>בטוח שאתם רוצים לצאת?</div>
          <h5 className='leave_text'>
            אם תרצו להשלים את ההצטרפות <br />
            בהמשך, תצטרכו להתחיל מחדש.
          </h5>

          <div className='btn-wrapper'>
            <BtnSubmit onclick={() => setShowLobbyPopup(false)} text='חזור לתהליך'></BtnSubmit>
          </div>

          <div className='btn-wrapper leave_link'>
            <BtnSubmit onclick={() => goToLobby()} text='לעמוד הבית'></BtnSubmit>
          </div>
        </div>
      </PopUp>

    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SalesHeader);
